// import React, { useState } from "react";
// import { IoWarningOutline } from "react-icons/io5";
// import DefaultInput from "../inputs/defaultInput";
// import { AiOutlineLoading } from "react-icons/ai";

// const ConfirmModal = ({
//   isOpen,
//   title,
//   message,
//   onConfirm,
//   onCancel,
//   isInput,
//   value,
//   setValue,
//   loading = false,
// }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-lg shadow-lg p-6 w-96">
//         {/* Header */}
//         <div className="">
//           <div className="flex flex-col items-center">
//             <IoWarningOutline className="text-4xl text-red-600" />
//             <h2 className="text-lg font-semibold text-theme">{title}</h2>
//           </div>
//         </div>

//         {/* Body */}
//         <div className="text-center">
//           <p className="mb-6">{message}</p>
//         </div>
//         {isInput && (
//           <div className="text-center flex flex-col gap-2 my-2">
//             <DefaultInput
//               label={"Invoice Title"}
//               name="name"
//               value={value}
//               onChange={(e) => setValue(e.target.value)}
//             />
//           </div>
//         )}

//         {/* Footer */}
//         <div className="flex justify-center gap-2">
//           <button
//             onClick={onCancel}
//             className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
//           >
//             Cancel
//           </button>
//           <button
//             disabled={loading}
//             onClick={onConfirm}
//             className="px-4 py-2 bg-primary-900 flex items-center gap-2 text-white rounded-lg hover:bg-theme"
//           >
//             {loading ? (
//               <AiOutlineLoading
//                 speed={2}
//                 className="animate-spin text-md rounded-full
//                     text-white"
//               />
//             ) : null}
//             Confirm
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ConfirmModal;


import React from "react";
import { IoWarningOutline } from "react-icons/io5";
import DefaultInput from "../inputs/defaultInput";
import { AiOutlineLoading } from "react-icons/ai";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  isInput,
  value,
  setValue,
  loading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        {/* Header */}
        <div className="flex flex-col items-center">
          <IoWarningOutline className="text-4xl text-red-600" />
          <h2 className="text-lg font-semibold text-theme">{title}</h2>
        </div>

        {/* Body */}
        <div className="text-center">
          <p className="mb-6">{message}</p>
        </div>

        {isInput && (
          <div className="text-center flex flex-col gap-2 my-2">
            <DefaultInput
              label="Invoice Title"
              name="name"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
        )}

        {/* Footer */}
        <div className="flex justify-center gap-2">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            disabled={loading}
            onClick={onConfirm}
            className="px-4 py-2 bg-primary-900 flex items-center justify-center text-white rounded-lg hover:bg-gradient-to-r hover:from-[#1E3A8A] hover:to-[#3B82F6] disabled:opacity-50 w-28"
          >
            {loading ? (
              <AiOutlineLoading className="animate-spin text-lg text-white" />
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
